<template>
  <section id="about-us" class="grey lighten-4">
    <vertical-divider :class="'vertical'" />
    <v-container class="extra-padding" fluid>
      <v-row justify="center" mb="10" class="mb-10">
        <!-- <v-col cols="10" class="mb-10">
          <h1 class="text-center text-h3 text-uppercase font-weight-black">
            ARGECAM S.R.L
          </h1>
          <v-divider
            color="white"
            class="pt-1 mx-auto my-2"
            width="50"
          ></v-divider>
        </v-col> -->
        <v-col cols="12" sm="6" md="5">
          <v-img
            width="100%"
            class="rounded-lg elevation-10"
            :src="require('@/assets/section/section-about.jpeg')"
          ></v-img>
        </v-col>
        <v-col cols="12" md="5">
          <h1 class="text-h2 text-uppercase text-center primary--text">
            Nuestra Empresa
          </h1>
          <v-divider class="pt-1 mx-auto my-2 secondary" width="50"></v-divider>
          <br />
          <p class="primary--text text-justify font-weight-light">
            Somos una empresa vial especializada en movimiento de suelo y
            excavaciones de grandes volúmenes afianzada en el rubro con más de
            15 años en el mercado de la construcción, contamos con los equipos
            viales necesarios para que la obra se efectúe de forma eficiente,
            utilizando la última tecnología en nuestros equipos, invirtiendo en
            capacitación de nuestros profesionales e infraestructura, así
            continuaremos avanzando respetando nuestros ideales y ayudando a
            convertir los proyectos en realidades concretas.
          </p>
          <p class="primarys--text text-justify font-weight-light">
            Desde su creación, la empresa ha desarrollado su actividad en tareas
            de movimiento de suelos, excavaciones, demoliciones, alquiler de
            equipos viales siendo contratada tanto en el ámbito privado como en
            el estatal.
          </p>
          <v-btn color="primary" to="nuestra-empresa">
            Ver más
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "About-Us",
  components: {
    VerticalDivider: () => import("@/components/shape/VerticalDivider.vue")
  }
};
</script>
